import * as z from "zod";

import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const recurringJobConfigSchema = z
  .object({
    amount: z.number().min(0, REQUIRED_MESSAGE),
    currency: requiredString(),
    billing_interval: z.number().min(1, REQUIRED_MESSAGE),
    billing_frequency: z.enum(["weekly", "monthly", "yearly"], {
      required_error: REQUIRED_MESSAGE,
    }),
    billing_by_week_day: z.number().min(0).max(6).nullable().optional(),
    billing_by_month_date: z.number().min(1).max(31).nullable().optional(),
    billing_by_month: z.number().min(0).max(11).nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.billing_frequency === "weekly") {
      if (data.billing_by_week_day === null || data.billing_by_week_day === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: REQUIRED_MESSAGE,
          path: ["billing_by_week_day"],
        });
      }
    } else if (data.billing_frequency === "monthly") {
      if (data.billing_by_month_date === null || data.billing_by_month_date === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: REQUIRED_MESSAGE,
          path: ["billing_by_month_date"],
        });
      }
    } else if (data.billing_frequency === "yearly") {
      if (data.billing_by_month === null || data.billing_by_month === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: REQUIRED_MESSAGE,
          path: ["billing_by_month"],
        });
      }
    }
  });
